import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Collapse, Card } from "react-bootstrap";
import { DatePicker } from "antd";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import ScheduleFiltersItem from "components/menu/schedule/filter/filters-item";
import { scheduleModsMerchandiser } from "data/schedule-mods";
import SelectExtended from "components/custom/forms/select-extended";

class SchedulingNewFilters extends React.PureComponent {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.handleFilter = this.handleFilter.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleSetDate = this.handleSetDate.bind(this);

        this.state = {
            isOpen: false,
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    handleSetDate = (name, value) => {
        const newState = {};

        newState[name] = value;
        this.setState(newState, () => {
            const dateString = value === null
                ? null
                : value.format(this.dateFormat);
            this.handleFilter(name, dateString);
        });
    };

    handleFilter(filterKey, value) {
        this.props.filterCallback(filterKey, value);
    }

    handleSearch () {
        this.props.onCheckCanSearch(this.props.activeFilters, () => {
            this.setState({
                isOpen: false
            });
            this.props.onSearch();
        });

        this.validator.showMessages();
        this.forceUpdate();
    }

    handleReset (callback = false) {
        this.props.onReset(callback);
    }

    render() {
        const {
            filters,
            activeFilters,
            titleFilteredCounts,
            showMerchandisers
        } = this.props;

        const {
            isOpen,
        } = this.state;

        const stores = {};
        if (filters.stores) {
            Object.keys(filters.stores).forEach(storeId => {
                stores[storeId] = `${filters.stores[storeId].storeNumber} - ${filters.stores[storeId].retailer}`;
            });
        }

        const modeOptions = Object.keys(scheduleModsMerchandiser).map(key => ({
            label: scheduleModsMerchandiser[key].title,
            value: scheduleModsMerchandiser[key].value
        }));

        return (
            <div className="position-relative mb-4" style={{ zIndex: 10 }}>
                <Card className=" mb-2">
                    <Card.Header>
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="m-0">
                                {this.props.title}
                            </h4>
                            <div>
                                <span className="text-success mr-3" title="Service count">
                                    {`Services: ${titleFilteredCounts.totalFilteredRecords}`}
                                </span>
                                <Button
                                    onClick={() => this.setState({ isOpen: !isOpen })}
                                    aria-expanded={isOpen}
                                >
                                    {`${isOpen ? "Close" : "Expand"} Search`}
                                </Button>
                            </div>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Collapse in={isOpen} className="col-12 p-3">
                            <div className="row">
                                <div className="col-lg-9 col-md-9 col-sm-12">
                                    <div className="row">
                                        <div className="col-lg-3 col-md-5 col-sm-6">
                                            <ScheduleFiltersItem
                                                label="Jobs"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("jobIds", item)}
                                                filterObj={filters.jobs || {}}
                                                valuesObj={activeFilters.jobIds || false}
                                            />

                                            <ScheduleFiltersItem
                                                label="Store#"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("storeIds", item)}
                                                filterObj={stores}
                                                valuesObj={activeFilters.storeIds || false}
                                            />
                                            <ScheduleFiltersItem
                                                label="Retailers"
                                                isMulti={true}
                                                onChange={(item) => this.handleFilter("retailerIds", item)}
                                                filterObj={filters.retailers || {}}
                                                valuesObj={activeFilters.retailerIds || false}
                                            />
                                        </div>
                                        <div className="col-lg-3 col-md-5 col-sm-6">
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">
                                                    From Date
                                                </label>
                                                <DatePicker
                                                    value={activeFilters.earliestDate
                                                        ? moment(activeFilters.earliestDate)
                                                        : null
                                                    }
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("earliestDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (activeFilters.latestDate === null) {
                                                            return false;
                                                        }
                                                        // eslint-disable-next-line max-len
                                                        return current && current >= moment(activeFilters.latestDate);
                                                    }}
                                                    className="d-block"
                                                    allowClear={true}
                                                />
                                                {this.validator.message("earliestDate", activeFilters.earliestDate, "required")}
                                            </div>
                                            <div className="mb-1 draft-filter-wrapper form-group">
                                                <label className="d-block mb-0 font-weight-bold form-label">
                                                    To Date
                                                </label>
                                                <DatePicker
                                                    value={activeFilters.latestDate
                                                        ? moment(activeFilters.latestDate)
                                                        : null
                                                    }
                                                    format={this.dateFormat}
                                                    onChange={date => {
                                                        this.handleSetDate("latestDate", date);
                                                    }}
                                                    disabledDate={(current) => {
                                                        if (activeFilters.earliestDate === null) {
                                                            return false;
                                                        }
                                                        // eslint-disable-next-line max-len
                                                        return current && current <= moment(activeFilters.earliestDate);
                                                    }}
                                                    className="d-block"
                                                />
                                                {this.validator.message("latestDate", activeFilters.latestDate, "required")}
                                            </div>
                                            <div className="mb-1 draft-filter-wrapper">
                                                <label className="mb-0 font-weight-bold">
                                                    Mode
                                                </label>
                                                <div className="d-block">
                                                    <SelectExtended
                                                        options={modeOptions}
                                                        isLoading={false}
                                                        isClearable={false}
                                                        isSearchable={true}
                                                        isMulti={false}
                                                        value={activeFilters.mode || {
                                                            label: scheduleModsMerchandiser.Open.title,
                                                            value: scheduleModsMerchandiser.Open.value
                                                        }}
                                                        onChange={(item) => this.handleFilter("mode", item)}
                                                        className="filter-select"
                                                        classNamePrefix="filter-select"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-3 col-sm-12">
                                    <div className="h-100 d-flex flex-column justify-content-around">
                                        <Button
                                            className="mt-1"
                                            variant="primary"
                                            onClick={this.handleSearch}
                                        >
                                            Search
                                        </Button>
                                        <Button
                                            className="mt-1"
                                            variant="secondary"
                                            onClick={this.handleReset}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            className="mt-1"
                                            variant="secondary"
                                            onClick={this.props.onExport}
                                        >
                                            Export
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

SchedulingNewFilters.defaultProps = {
    filters: {
        jobs: [],
        merchandisers: [],
        earliestDate: null,
        latestDate: null,
    }
};

SchedulingNewFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    onExport: PropTypes.func.isRequired,
    filterCallback: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    titleFilteredCounts: PropTypes.object.isRequired,
    showMerchandisers: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
    loading: state.globalFormErrors.loading
});

export default connect(
    mapStateToProps
)(SchedulingNewFilters);
